module.exports = __webpack_public_path__ + "img/95763f4.png";